import React from 'react';
import './App.scss';
import Header from './Header';
import About from './About'
import Contact from './Contact'
import InterestForm from './InterestForm'
import ErrorForm from './ErrorForm'
import { Route, HashRouter  as Router } from 'react-router-dom'

class App extends React.Component {

  render() {
    return (
      <Router>
        <div className='app'>
          <div className='header'>
            <Header />
          </div>
          <div className='title'>GLIMMA FASTIGHETER AB</div>
          <div className='main'>
            <Route exact path="/" component={About} />
            <Route path="/startsida" component={About} />
            <Route path="/intresseanmalan" component={InterestForm} />
            <Route path="/felanmalan" component={ErrorForm} />
            <Route path="/kontakt" component={Contact} />
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
